import { Tabs as TabsPrimitive } from 'radix-ui';
import { cn } from '../lib/utils.js';

/** @param {import('react').ComponentProps<typeof TabsPrimitive.Root>} props */
export function Tabs({ className, ...props }) {
  return <TabsPrimitive.Root data-slot="tabs" className={cn('flex flex-col gap-3', className)} {...props} />;
}

/** @param {import('react').ComponentProps<typeof TabsPrimitive.List>} props */
export function TabsList({ className, ...props }) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn('inline-flex w-fit max-w-full items-center gap-1 overflow-x-auto border-b text-muted-foreground', className)}
      {...props}
    />
  );
}

/** @param {import('react').ComponentProps<typeof TabsPrimitive.Trigger>} props */
export function TabsTrigger({ className, ...props }) {
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(
        '-mb-px inline-flex h-(--control-height) items-center gap-1.5 whitespace-nowrap border-b-2 border-transparent px-3 text-sm font-medium transition-colors hover:text-foreground disabled:opacity-50 data-[state=active]:border-primary data-[state=active]:text-foreground',
        className,
      )}
      {...props}
    />
  );
}

/** @param {import('react').ComponentProps<typeof TabsPrimitive.Content>} props */
export function TabsContent({ className, ...props }) {
  return <TabsPrimitive.Content data-slot="tabs-content" className={cn('outline-none', className)} {...props} />;
}
